import React from 'react'
import { useDestinationsContext } from '../../../../Contexts/DestinationsContext'
import { useOrderContainersContext } from '../../../../Contexts/OrderContainersContext'
import { EnvironmentOutlined, SplitCellsOutlined } from '@ant-design/icons'
import { Empty } from 'antd'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'

export const MoveDropdown = ({ isMulti, pocketProduct, pocketStore, pocketIndex, setOptionsVisible }) => {
  const { orderDestinations, getImpactedTankVolumes, setOrderDestinations } = useDestinationsContext()
  const { setOrderEdited } = useWizardMaster()
  const { movePocketDestination, addCompartmentTarget, removeTarget } = useOrderContainersContext()
  const dropDownOptions = []
  const destCopy = [...orderDestinations]
  const buttonClick = (store) => {
    const tankMatch = store.tanks.find((t) => t.product.toUpperCase() === pocketProduct.toUpperCase()).tank_id
    setOptionsVisible(false)
    movePocketDestination(pocketIndex, store.store_number, tankMatch, getImpactedTankVolumes, setOrderDestinations)
    isMulti && removeTarget(pocketIndex)
    setOrderEdited(true)
  }

  const filteredOutStores = destCopy.filter(
    (d) =>
      d.store_number !== pocketStore && d.tanks.some((t) => pocketProduct.toUpperCase() === t.product.toUpperCase())
  )
  const enableMulti = () => {
    addCompartmentTarget(
      pocketIndex,
      filteredOutStores[0].store_number,
      filteredOutStores[0].tanks.find((t) => t.product.toUpperCase() === pocketProduct.toUpperCase()).tank_id
    )
    setOptionsVisible(false)
  }

  filteredOutStores.forEach((s, i) =>
    dropDownOptions.push(
      <div>
        <a
          key={i}
          style={{ fontSize: '1.2em', color: 'var(--gray-800)' }}
          onClick={() => {
            buttonClick(s)
          }}
          className='pb-3'
        >
          <EnvironmentOutlined className='pr-2' />
          {s.store_number}
        </a>
      </div>
    )
  )

  if (dropDownOptions.length > 0 && !isMulti) {
    dropDownOptions.push(
      <div key='both'>
        <a onClick={() => enableMulti()} className='mb-3' style={{ fontSize: '1.2em', color: 'var(--gray-800)' }}>
          <SplitCellsOutlined className='pr-2' /> Multi
        </a>
      </div>
    )
  } else if (!isMulti) {
    dropDownOptions.push(
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={`No other ${pocketProduct} tanks to move to.`} />
    )
  }
  return dropDownOptions
}
